import { render, staticRenderFns } from "./exhibition-register-admin.vue?vue&type=template&id=5d282864&scoped=true&"
import script from "./exhibition-register-admin.vue?vue&type=script&lang=js&"
export * from "./exhibition-register-admin.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-register-admin.vue?vue&type=style&index=0&id=5d282864&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d282864",
  null
  
)

export default component.exports